<template>
  <section class="empty-wrapper">
    <img src="./images/empty.svg" />
    <span>暂无数据</span>
  </section>
</template>

<script setup>
  
</script>

<style scoped lang="less">
@import "./index.less";
</style>
